import {
  FormControl,
  FormHelperText,
  FormLabel,
  InputLabel,
  MenuItem,
  Select,
  styled,
  Tooltip,
} from "@mui/material";
import { Controller } from "react-hook-form";

const CustomBorderSelect = styled(Select)`
  &.Mui-focused {
    & fieldset {
      border-color: #3a3a3a !important;
    }
  }
`;

const ReactSelect = (props) => {
  const {
    hookFormControl,
    label,
    formLabel,
    varName,
    disabled = false,
    options,
    errorMessage = null,
    isMultiSelect = false,
    withSelect = true,
    size = "small",
    variant = "outlined",
    helperText = null,
    width = "100%",
    placeholder = "",
    required = false,
    onChange,
  } = props;

  const renderValue = (selected) => {
    if (!selected || selected.length === 0)
      return <span className="text-[#b9b9b9]">{placeholder}</span>;
    if (isMultiSelect) {
      const selectedOptions = options
        .filter((a) => selected.includes(a.value))
        .map((a) => a.label)
        .join(",");

      return <Tooltip title={selectedOptions}>{selectedOptions}</Tooltip>;
    }
    const selectedOption = options?.find((item) => item.value === selected);
    return (
      <div className="flex gap-2 items-center text-black">
        {selectedOption?.color && (
          <span
            className="w-3 h-3"
            style={{ backgroundColor: selectedOption.color }}
          />
        )}
        {selectedOption?.label ?? ""}
      </div>
    );
  };

  return (
    <FormControl
      error={errorMessage !== null}
      size={size}
      required={required}
      fullWidth
      sx={{ width }}
    >
      {formLabel && (
        <FormLabel className="text-[16px] font-['Matter-Medium'] text-black mb-2">
          {formLabel}
        </FormLabel>
      )}
      <InputLabel
        error={false}
        disabled={disabled}
        htmlFor={varName}
        className="font-['Poppins-Regular'] text-[15px]"
      >
        {label}
      </InputLabel>
      <Controller
        name={varName}
        control={hookFormControl}
        render={({ field }) => (
          <CustomBorderSelect
            id={varName}
            label={label}
            required={required}
            variant={variant}
            disabled={disabled}
            readOnly={props?.readOnly}
            size={size}
            {...field}
            onChange={(e) => {
              field.onChange(e);
              onChange?.(e.target.value);
            }}
            renderValue={renderValue}
            error={false}
            displayEmpty
            inputProps={{ className: "font-['Poppins-Regular'] text-[15px]" }}
            value={field?.value ? field.value : isMultiSelect ? [] : ""}
            multiple={isMultiSelect}
            sx={{ fontFamily: "Poppins-Regular", fontSize: "14px" }}
          >
            {withSelect && (
              <MenuItem
                value={""}
                key={"def-numb"}
                sx={{
                  fontFamily: "Poppins-Regular",
                  fontSize: "14px",
                  color: isMultiSelect ? "#a4a4a4" : "",
                }}
                disabled={isMultiSelect || options.length === 0}
              >
                <em>Select {label}</em>
              </MenuItem>
            )}

            {options.map((a) => (
              <MenuItem
                className="flex gap-2 items-center"
                sx={{ fontFamily: "Poppins-Regular", fontSize: "14px" }}
                title={a?.info ?? a.label}
                disabled={a.disabled ? true : false}
                value={a.value}
                key={a.label}
              >
                {a?.color && (
                  <span
                    className="w-3 h-3"
                    style={{ backgroundColor: a.color }}
                  />
                )}
                {a.label}
              </MenuItem>
            ))}
          </CustomBorderSelect>
        )}
      />
      {!errorMessage && helperText && (
        <FormHelperText
          className="ml-0 font-['Poppins-Regular']"
          id="component-info-text"
        >
          {helperText}
        </FormHelperText>
      )}
      {errorMessage && (
        <FormHelperText
          className="ml-0 font-['Poppins-Regular']"
          id="component-error-text"
        >
          {errorMessage}
        </FormHelperText>
      )}
    </FormControl>
  );
};

export default ReactSelect;
